import {
  Avatar,
  AvatarBadge,
  Box,
  Flex,
  HStack,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import {
  BsFillCheckCircleFill,
  BsFillStarFill,
  BsFillSuitHeartFill,
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default function FreelancerCard({
  title,
  description,
  coverImageUrl,
  profileImageUrl,
  price,
  level,
  verified,
  online,
  pro,
}) {
  const navigate = useNavigate();
  return (
    <Stack
      borderRadius={10}
      overflow="hidden"
      onClick={() => {
        navigate("/gig/logo-master");
      }}
      sx={{ cursor: "pointer" }}
      justifyContent="space-between"
      border="1px solid #c5c5c5"
      minWidth={{ lg: "260px" }}
      pos="relative"
      spacing={0}
    >
      <Image src={coverImageUrl} />
      <Box pos="relative" bottom={8} px={4}>
        <Flex justifyContent={"space-between"}>
          <HStack alignItems="end">
            <Avatar src={profileImageUrl} size={"lg"}>
              {online && <AvatarBadge bg={"00D900"} />}
            </Avatar>
          </HStack>
          {level ? (
            <Box>
              <Text
                align="center"
                py={2}
                pos="relative"
                top="15px"
                w="120px"
                borderRadius={"10px 0px 10px 0px"}
                color="white"
                bgGradient={
                  level !== "top"
                    ? `linear(to-b,${
                        level === 1 ? "#52B9F3,#0079BC" : "#B352F3,#0079BC"
                      })`
                    : "linear(to-b,#F3B12C,#BC6400)"
                }
              >
                {level === 1 && "Level 1"}
                {level === "top" && "Top Rated"}
                {level === 2 && "Level 2"}
              </Text>
            </Box>
          ) : (
            <Stack justify="end">
              {verified ? (
                <Image src="/images/marketplace-category/verified.png" />
              ) : (
                <Text fontSize="12px" fontWeight="semibold" color="#727272">
                  Unverified
                </Text>
              )}
            </Stack>
          )}
        </Flex>
        <Flex justifyContent={"space-between"} pt={4}>
          <HStack color="#0079BC">
            <Text fontWeight="bold">{title}</Text>
            {verified && !level && <BsFillCheckCircleFill color="#52B9F3" />}
          </HStack>
          <HStack>
            <Box color="#FFBE5B">
              <BsFillStarFill />
            </Box>
            <Text fontWeight="bold">4.8</Text>
            <Text color="gray.500" fontWeight="bold">
              (2k)
            </Text>
          </HStack>
        </Flex>
        <Text pt={4} fontWeight="semibold" color="black">
          {description}
        </Text>
      </Box>
      <Flex
        px={4}
        justifyContent="space-between"
        alignItems={"center"}
        bg={"#f7f7f7"}
        borderTop="1px solid #c5c5c5"
        py={4}
      >
        <Flex alignItems="end" gap={2}>
          <Text fontSize={22} fontWeight="bold">
            US${price}
          </Text>
          <Text pb={1} fontSize={"13"} color="gray">
            Starting from
          </Text>
        </Flex>
        <Box color="brand.900">
          <BsFillSuitHeartFill />
        </Box>
      </Flex>
      {pro && (
        <Box pos="absolute" top={0} left={5} sx={{ marginTop: "0px" }}>
          <Image src="/images/gigImage/pro.png" w="45px" />
        </Box>
      )}
    </Stack>
  );
}
